import React from "react";
import logoDark from "../assets/torri-horizontal-dark.png"; // white text — for dark backgrounds
import logoLight from "../assets/torri-horizontal-light.png"; // black text — for light backgrounds

// Official TORRI horizontal logo (real brand file, aspect ratio preserved — no distortion).
// onDark=true -> white-text variant (dark backgrounds like header/footer)
export default function TorriLogo({ height = 38, onDark = true, className = "" }) {
  return (
    <img
      src={onDark ? logoDark : logoLight}
      alt="TORRI — Beyond Ordinary Solar"
      className={className}
      style={{ height, width: "auto", display: "block" }}
      draggable={false}
    />
  );
}
